import React, { useState } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ReactComponent as More } from "../static/Icons/more.svg";
import { ReactComponent as BackIcon } from "../static/Icons/arrow-left.svg";
import { ReactComponent as Google } from "../static/Icons/google.svg";
import { ReactComponent as Configure } from "../static/Icons/configure.svg";
import { ReactComponent as Test } from "../static/Icons/test.svg";
import { ReactComponent as History } from "../static/Icons/history.svg";
import { ReactComponent as Delete } from "../static/Icons/trash.svg";
import {
  connectTool,
  deleteToolActionById,
  updateActionNeeds,
} from "../api/tool";
import { getServerById } from "../api/server";
import { showErrorToast, showSuccessToast } from "../toastUtils";
import CommonModal from "../CommonComponents/CommonModal";
import ButtonCommon from "../CommonComponents/ButtonCommon";

const menuItems = [
  { label: "Configure", icon: Configure },
  { label: "Test", icon: Test },
  { label: "History", icon: History },
  { label: "Delete", icon: Delete },
];

const formatLabel = (text) => {
  if (!text) return "";
  return text
    .split("_")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
};

// Helper for dynamic icon rendering (same as in ServerDetails.js/ToolsPage.js)
const renderToolIcon = (tool, size = 42) => {
  // Dynamic require is wrapped in try/catch to avoid build errors if the file is missing.
  // This is safe for production builds because the fallback will always be used if require fails.
  if (tool && tool.toolIcon) {
    try {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return (
        <img
          src={require(`../static/Icons/${tool.toolIcon}`)}
          alt={tool.toolName || tool.actionName}
          style={{
            width: size,
            height: size,
            objectFit: "contain",
            borderRadius: 8,
          }}
        />
      );
    } catch (e) {
      try {
        // eslint-disable-next-line global-require, import/no-dynamic-require
        return (
          <img
            src={require(`../static/Icons/default-tool.svg`)}
            alt="default-tool"
            style={{
              width: size,
              height: size,
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        );
      } catch (e2) {
        return <Google style={{ width: size, height: size }} />;
      }
    }
  }
  try {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    return (
      <img
        src={require(`../static/Icons/default-tool.svg`)}
        alt="default-tool"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          borderRadius: 8,
        }}
      />
    );
  } catch (e) {
    return <Google style={{ width: size, height: size }} />;
  }
};

export default function ActionPage({
  setServerDetails,
  toolActionData,
  setSelectedTab,
}) {
  const [selectedAction, setSelectedAction] = useState(null);
  const [anchorElMap, setAnchorElMap] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteToolActionId, setDeleteToolActionId] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);

  const [finalConnectModal, setFinalConnectModal] = useState(false);
  const [selectedTool, setSelectedTool] = useState(null);
  const [oauthMethod, setOauthMethod] = useState("");
  const [loading, setLoading] = useState(false);
  const [tokenError, setTokenError] = useState("");
  const [personalAccessToken, setPersonalAccessToken] = useState("");

  // const [openConfigureModal, setOpenConfigureModal] = useState(false);

  console.log(toolActionData, "toolActionData");

  // const [createValue, setCreateValue] = useState({});
  const [showManualInput, setShowManualInput] = useState({});
  const [manualValue, setManualValue] = useState({});
  const [updateActionNeedLoading, setUpdateActionNeedLoading] = useState(false);

  const handleMenuOpen = (event, actionId) => {
    event.stopPropagation();
    setAnchorElMap((prev) => ({ ...prev, [actionId]: event.currentTarget }));
  };

  console.log("selected action", selectedAction);

  const handleMenuClose = (e, label, action) => {
    e.stopPropagation();
    setAnchorElMap((prev) => ({ ...prev, [action.actionId]: null }));

    switch (label) {
      case "Configure":
        // setOpenConfigureModal(true);
        setSelectedAction(action);
        break;
      case "Test":
        break;
      case "History":
        break;
      case "Delete":
        setDeleteToolActionId(action.actionId);
        setOpenDeleteModal(true);
        break;
      default:
        break;
    }
  };

  const deleteToolAction = async (actionId) => {
    setDeleteLoader(true);
    try {
      const res = await deleteToolActionById(actionId);
      if (res.success) {
        const serverId = localStorage.getItem("server_id");
        const resData = await getServerById(serverId);
        setServerDetails(resData.data);
        setSelectedTab(0);
        showSuccessToast(res.message);
      } else {
        showErrorToast(res.message);
      }
    } catch (error) {
      console.error("Error deleting tool:", error);
      showErrorToast(error?.message || "Failed to delete");
    } finally {
      setDeleteLoader(false);
      setOpenDeleteModal(false);
      setDeleteToolActionId(null);
    }
  };

  const handleSubmit = async () => {
    // console.log("ShowManualInput ID:", showManualInput);
    // console.log("Manual Value:", manualValue);

    // const payload = {
    //   action_key: "create_repo",
    //   action_description:
    //     "Creates a new repository under the authenticated user's account or organization.",
    //   action_type: "github",
    //   action_id: "8c9a5b67-7c3e-432f-8062-4f062dad6eba",
    //   action_name: "create_repo",
    //   action_needs: {
    //     name: {
    //       custom_field: false,
    //       alters_custom_fields: null,
    //       param: "name",
    //       parent_key: null,
    //       type: "string",
    //       required: true,
    //       help_text: "",
    //     },
    //     description: {
    //       custom_field: false,
    //       alters_custom_fields: null,
    //       param: "description",
    //       parent_key: null,
    //       type: "string",
    //       required: false,
    //       help_text: "",
    //     },
    //     private: {
    //       custom_field: false,
    //       alters_custom_fields: null,
    //       param: "private",
    //       parent_key: null,
    //       type: "boolean",
    //       required: false,
    //       help_text: "",
    //     },
    //     org: {
    //       custom_field: false,
    //       alters_custom_fields: null,
    //       param: "org",
    //       parent_key: null,
    //       type: "string",
    //       required: false,
    //       help_text: "",
    //     },
    //   },
    //   action_display_name: "github: Create Repository",
    //   is_hidden: false,
    // };

    const updatedActionNeeds = {};

    // Dynamically loop through all fields in action_needs
    Object.entries(selectedAction.actionNeeds).forEach(([key, value]) => {
      const isManual = showManualInput?.[key] === "manual";
      const manualVal = manualValue?.[key];

      updatedActionNeeds[key] = {
        ...value,
        value: isManual ? manualVal : "$$$GUESS$$$",
        // custom_field: isManual,
        // ...(isManual && { custom_value: manualVal }),
      };
    });

    const payload = {
      // action_key: selectedAction.action_key,
      // action_description: selectedAction.action_description,
      // action_type: selectedAction.action_type,
      // action_id: selectedAction.action_id,
      // action_name: selectedAction.action_name,
      // action_display_name: selectedAction.action_display_name,
      // is_hidden: selectedAction.is_hidden,
      // action_needs: updatedActionNeeds,
      ...updatedActionNeeds,
    };

    setUpdateActionNeedLoading(true);
    try {
      const res = await updateActionNeeds(selectedAction.actionId, payload);
      if (res.success) {
        const serverId = localStorage.getItem("server_id");
        const resData = await getServerById(serverId);
        setServerDetails(resData.data);
        showSuccessToast(res.message);
      } else {
        showErrorToast(res.message);
      }
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      setUpdateActionNeedLoading(false);
      setSelectedAction(null);
      setManualValue({});
      setShowManualInput({});
    }
  };
  const handleToolConnect = async (method, provider) => {
    setLoading(true);
    try {
      // Get authScope from the action's tool data in toolActionData
      // toolActionData contains the grouped actions by tool with tool metadata
      let authScope = provider?.authScope;
      
      // If authScope is not available in provider (action object), 
      // find it from the parent tool in toolActionData
      if (!authScope && toolActionData?.toolActions) {
        // Find the tool that contains this action
        for (const toolAction of toolActionData.toolActions) {
          if (toolAction.toolName === provider?.toolName) {
            authScope = toolAction.authScope;
            break;
          }
        }
      }
      
      const payload = {
        provider: provider?.toolName,
        scopes: Array.isArray(authScope)
          ? authScope.join(",")
          : "",
        redirect: `${window.location.origin}/dashboard/oauth/callback`,
        auth_method: method,
      };

      if (method === "personal_access_token") {
        payload.access_token = personalAccessToken;
      }

      const res = await connectTool(payload);

      if (res?.data?.auth_url) {
        setLoading(false);
        localStorage.setItem("oauthResponse", JSON.stringify(res));

        window.location.href = res.data.auth_url;
      } else {
        setLoading(false);
        showErrorToast(res?.message);
      }
    } catch (err) {
      setLoading(false);
      showErrorToast(err);
    }
  };

  const handleChange = (event) => {
    const selectedMethod = event.target.value;
    setOauthMethod(selectedMethod);

    // If not personal token, call API immediately
    if (selectedMethod !== "personal_access_token") {
      handleToolConnect(selectedMethod, selectedTool);
    }
  };

  const handleTokenSubmit = () => {
    if (!personalAccessToken.trim()) {
      setTokenError("Access token is required");
      return;
    }
    setTokenError("");
    handleToolConnect("personal_access_token", selectedTool);
  };

  const fieldObject = selectedAction && selectedAction?.actionNeeds;

  // useEffect(() => {
  //   if (selectedAction) {
  //     const initialShowManualInput = {};
  //     const initialManualValue = {};

  //     fieldObject.forEach((field) => {
  //       initialShowManualInput[field] =
  //         selectedAction?.action_needs[field].value !== "$$$GUESS$$$"
  //           ? "manual"
  //           : null;
  //       initialManualValue[field] =
  //         selectedAction?.action_needs[field].value !== "$$$GUESS$$$"
  //           ? selectedAction?.action_needs[field].value
  //           : null;
  //     });

  //     setShowManualInput(initialShowManualInput);
  //     setManualValue(initialManualValue);
  //   }

  //   // eslint-disable-next-line
  // }, [selectedAction]);

  return (
    <>
      {!selectedAction ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            height: "calc(100vh - 250px)",
            overflowY: "auto",
            backgroundColor: "#000",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          {(toolActionData?.toolActions || [])?.map((action) => {
            const isAuthPending =
              action.toolAuth === "false" ||
              toolActionData.toolAuth === "false";
            console.log("Action data", action);

            return (
              <Box
                key={action.actionId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                  cursor: "default",
                  background: isAuthPending ? "#FFC9C633" : "#2C2F3366",
                  border: "1px solid #50505030",
                  borderRadius: "4px !important",
                }}
              >
                <ListItemIcon
                  sx={{ minWidth: "40px", mr: 2, cursor: "pointer" }}
                  onClick={() => setSelectedAction(action)}
                >
                  {renderToolIcon(action, 30)}
                </ListItemIcon>
                <ListItemText
                  onClick={() => setSelectedAction(action)}
                  primary={action?.actionName}
                  secondary={action?.actionDescription}
                  sx={{
                    margin: 0,
                    "& .MuiTypography-root": {
                      margin: 0,
                    },
                    "& .MuiTypography-root.MuiListItemText-primary": {
                      color: "white",
                      fontSize: "0.95rem",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    },
                    "& .MuiTypography-root.MuiListItemText-secondary": {
                      color: "#BBBBBB",
                      fontSize: "0.85rem",
                      fontWeight: 400,
                    },
                    cursor: "pointer",
                  }}
                />

                <Box display="flex">
                  {isAuthPending && (
                    <ButtonCommon
                      onClick={() => {
                        setSelectedTool(action);
                        setFinalConnectModal(true);
                      }}
                      variant="contained"
                      size="small"
                    >
                      Finish Setup
                    </ButtonCommon>
                  )}
                  <IconButton
                    onClick={(e) => handleMenuOpen(e, action.actionId)}
                    sx={{ color: "white" }}
                  >
                    <Box
                      component={More}
                      sx={{ width: "20px", height: "20px" }}
                    />
                  </IconButton>
                  <Menu
                    anchorEl={anchorElMap[action.actionId]}
                    open={Boolean(anchorElMap[action.actionId])}
                    onClose={() =>
                      setAnchorElMap((prev) => ({
                        ...prev,
                        [action.actionId]: null,
                      }))
                    }
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                      sx: { bgcolor: "#444343", color: "#E3E3E3" },
                    }}
                  >
                    {menuItems.map(({ label, icon: IconComponent }) => (
                      <MenuItem
                        key={label}
                        onClick={(e) => handleMenuClose(e, label, action)}
                      >
                        <ListItemIcon sx={{ color: "#E3E3E3", width: 24 }}>
                          <Box
                            component={IconComponent}
                            sx={{ width: "20px", height: "20px" }}
                          />
                        </ListItemIcon>
                        <ListItemText primary={label} />
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>
              </Box>
            );
          })}
        </Box>
      ) : (
        <Box sx={{ bgcolor: "#D4E6FF17", p: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <IconButton
              sx={{ color: "white" }}
              onClick={() => setSelectedAction(null)}
            >
              <BackIcon />
            </IconButton>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 42,
                height: 42,
                bgcolor: "#C7D3EA1F",
              }}
            >
              <Box sx={{ width: "30px", height: "30px" }}>
                {renderToolIcon(selectedAction, 30)}
              </Box>
            </Box>
            <Typography
              sx={{
                color: "#D7D7D7",
                textTransform: "capitalize",
                fontWeight: 600,
              }}
            >
              {selectedAction?.actionName}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {(fieldObject || [])
              .filter((field) => field.required) // Only required fields
              .map((field) => {
                const fieldKey = field.param;

                return (
                  <React.Fragment key={fieldKey}>
                    <Box
                      sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize" }}>
                        {fieldKey}
                        <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <TextField
                        select
                        defaultValue="ai"
                        variant="outlined"
                        fullWidth
                        size="small"
                        onChange={(e) =>
                          setShowManualInput((prev) => ({
                            ...prev,
                            [fieldKey]: e.target.value,
                          }))
                        }
                        sx={{
                          bgcolor: "#171717",
                          input: {
                            color: "#474747",
                            backgroundColor: "#D8D8D8",
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { borderColor: "#444" },
                            "&:hover fieldset": { borderColor: "#666" },
                            "&.Mui-focused fieldset": { borderColor: "#888" },
                            backgroundColor: "#D8D8D8",
                          },
                        }}
                        InputLabelProps={{ style: { color: "#A1A1A1" } }}
                      >
                        <MenuItem value="ai">
                          Have AI generate a value for this field
                        </MenuItem>
                        <MenuItem value="manual">
                          Set a specific value for this field
                        </MenuItem>
                      </TextField>
                    </Box>

                    {showManualInput?.[fieldKey] === "manual" && (
                      <TextField
                        fullWidth
                        size="small"
                        onChange={(e) =>
                          setManualValue((prev) => ({
                            ...prev,
                            [fieldKey]: e.target.value,
                          }))
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#D8D8D8",
                            "& fieldset": { borderColor: "#444" },
                            "&:hover fieldset": { borderColor: "#666" },
                            "&.Mui-focused fieldset": { borderColor: "#888" },
                          },
                          "& .MuiOutlinedInput-root textarea": {
                            color: "#474747",
                            backgroundColor: "#D8D8D8",
                          },
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <ButtonCommon
                sx={{ width: "100px" }}
                onClick={() => setSelectedAction(null)}
              >
                Cancel
              </ButtonCommon>
              <ButtonCommon
                variant="contained"
                sx={{
                  width: "100px",
                  "&.Mui-disabled": {
                    backgroundColor: "#999",
                    color: "#fff",
                  },
                }}
                disabled={updateActionNeedLoading}
                onClick={handleSubmit}
              >
                {updateActionNeedLoading ? "Saving..." : "Save"}
              </ButtonCommon>
            </Box>
          </Box>
        </Box>
      )}

      {/* //CommonModal */}

      <CommonModal
        open={finalConnectModal}
        handleClose={() => {
          setFinalConnectModal(false);
        }}
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 30,
                height: 30,
                bgcolor: "#00000038",
                p: 0.7,
                borderRadius: 1,
              }}
            >
              {renderToolIcon(selectedTool, 30)}
            </Box>
            <Typography sx={{ color: "white", textTransform: "capitalize" }}>
              {selectedTool?.toolName}
            </Typography>
          </Box>
        }
        cancelText="Cancel"
        cancelProps={{
          onClick: () => {
            setFinalConnectModal(false);
          },
        }}
        submitText=""
        submitProps={{
          sx: {
            display: "none",
          },
          // children: loading ? <CircularProgress size={16} /> : "Save",
          // loading: loading,
          // disabled: !isAuthCompleted,
          // onClick: async () => {
          //   setLoading(true);
          //   try {
          //     if (isBulkAdd) {
          //       const allActions = selectedActions.map((action) => ({
          //         actionName: action.actionName,
          //         actionDisplayName: action.actionDisplayName,
          //         actionDescription: action.actionDescription,
          //         actionType: action.actionType,
          //         actionKey: action.actionKey,
          //         actionNeeds: action.actionNeeds,
          //         isHidden: action.isHidden,
          //       }));

          //       const finalPayload = {
          //         actions_data: {
          //           toolId: selectedTool.toolId,
          //           toolName: selectedTool.toolName,
          //           toolDescription: selectedTool.toolDescription,
          //           toolIcon: selectedTool.toolIcon,
          //           toolActions: allActions,
          //         },
          //       };

          //       await addActionInServer(finalPayload);
          //     } else {
          //       const payload = generateActionPayload(
          //         selectedTool,
          //         selectedActions
          //       );
          //       await addActionInServer({ actions_data: payload });
          //     }

          //     const res = await getServerById(id);
          //     setServerDetails(res.data);
          //     // Reset all modal-related states
          //     setFinalConnectModal(false);

          //     sessionStorage.removeItem("toolAuth");
          //   } catch (error) {
          //     console.error("Error saving action(s):", error);
          //   } finally {
          //     setLoading(false);
          //   }
          // },
        }}
      >
        <Box variant="outlined">
          <Box>
            <Typography sx={{ color: "#ECECEC", mb: 1 }}>
              GitHub account
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Box
                key={selectedTool?.toolId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0px",
                  padding: "10px",
                  cursor: "pointer",
                  background: "#2C2F3366",
                  border: "1px solid #50505030",
                  borderRadius: 2,
                }}
              >
                <ListItemIcon>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 30,
                      height: 30,
                      bgcolor: "#2C2F3366",
                      borderRadius: 1,
                      p: 0.7,
                    }}
                  >
                    {renderToolIcon(selectedTool, 30)}
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary={selectedTool?.toolName}
                  sx={{
                    margin: 0,
                    "& .MuiTypography-root": {
                      color: "white",
                      fontSize: "0.95rem",
                      fontWeight: 400,
                    },
                    textTransform: "capitalize",
                  }}
                />

                {/* <ButtonCommon
                    variant="contained"
                    sx={{
                      width: "fit-content",
                      height: "fit-content",
                      p: 0,
                      px: 1,
                    }}
                   
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={20} /> : "Connect"}
                  </ButtonCommon> */}

                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      minWidth: 150, // optional, based on layout
                      marginLeft: "auto", // optional, if you want to push it right
                    }}
                  >
                    <FormControl
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "white",
                        },
                        "& .MuiOutlinedInput-root": {
                          color: "white",
                          "& fieldset": {
                            borderColor: "primary.main",
                          },
                          "&:hover fieldset": {
                            borderColor: "primary.dark",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "primary.main",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "white",
                        },
                      }}
                    >
                      <InputLabel id="auth-method-label">
                        Auth Option
                      </InputLabel>
                      <Select
                        labelId="auth-method-label"
                        value={oauthMethod}
                        label="Auth Option"
                        onChange={handleChange}
                      >
                        {(
                          selectedTool?.authOptions ||
                          toolActionData?.authOptions ||
                          []
                        ).map((item) => (
                          <MenuItem key={item} value={item}>
                            {formatLabel(item)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Box>
              <Box>
                {oauthMethod === "personal_access_token" && (
                  <Box display={"flex"} alignItems={"center"} gap={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Enter Personal Access Token"
                      variant="outlined"
                      value={personalAccessToken}
                      onChange={(e) => {
                        setPersonalAccessToken(e.target.value);
                        if (tokenError) setTokenError("");
                      }}
                      // onBlur={handleTokenSubmit}
                      error={!!tokenError}
                      helperText={tokenError}
                      sx={{
                        input: { color: "white" },
                        "& label": { color: "white" },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": { borderColor: "primary.main" },
                          "&:hover fieldset": {
                            borderColor: "primary.dark",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "primary.main",
                          },
                        },
                      }}
                    />
                    <ButtonCommon
                      variant="contained"
                      sx={{
                        width: "fit-content",
                        height: "fit-content",
                        p: 0,
                        px: 1,
                      }}
                      onClick={handleTokenSubmit}
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={20} /> : "Connect"}
                    </ButtonCommon>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </CommonModal>

      {/* Delete Confirmation Modal */}
      <CommonModal
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        title="Delete Action"
        cancelText="Cancel"
        cancelProps={{
          variant: "outlined",
          onClick: () => setOpenDeleteModal(false),
          sx: { color: "#fff", borderColor: "#fff" },
        }}
        submitText={deleteLoader ? "Deleting..." : "Delete"}
        submitProps={{
          disabled: deleteLoader,
          variant: "contained",
          sx: {
            ...(deleteLoader && {
              backgroundColor: "#999",
              color: "#fff",
              "&.Mui-disabled": {
                backgroundColor: "#999",
                color: "#fff",
              },
            }),
          },
          onClick: () => deleteToolAction(deleteToolActionId),
        }}
      >
        <Box>
          <Typography variant="body1" color="white" sx={{ mb: 2 }}>
            Are you sure you want to delete this action?
          </Typography>
        </Box>
      </CommonModal>
    </>
  );
}

//  Configure Confirm Modal

//   <CommonModal
//   open={openConfigureModal}
//   // setOpen={setOpenDeleteModal}
//   handleClose={() => {
//     setOpenConfigureModal(false);
//   }}
//   title={
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//       <IconButton
//         sx={{ color: "white" }}
//         onClick={() => setSelectedAction(null)}
//       >
//         <BackIcon />
//       </IconButton>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           width: 42,
//           height: 42,
//           bgcolor: "#C7D3EA1F",
//         }}
//       >
//         <Box component={Google} sx={{ width: "30px", height: "30px" }} />
//       </Box>
//       {/* {console.log("selectedAction", selectedAction)} */}
//       <Typography sx={{ color: "#D7D7D7", texttfransform: "capitalize" }}>
//         {selectedAction?.action_display_name}
//       </Typography>
//     </Box>
//   }
//   cancelText="Cancel"
//   cancelProps={{
//     variant: "outlined",
//     onClick: () => {
//       setOpenConfigureModal(false);
//     },
//     sx: { color: "#fff", borderColor: "#fff" },
//   }}
//   submitText={"Submit"}
//   submitProps={{
//     // disabled: deleteLoader,
//     variant: "contained",
//     onClick: () => deleteToolAction(deleteToolActionId),
//   }}
// >
//   <Box variant="outlined" sx={{ borderRadius: "10px" }}>
//     {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//       <IconButton
//         sx={{ color: "white" }}
//         onClick={() => setSelectedAction(null)}
//       >
//         <BackIcon />
//       </IconButton>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           width: 42,
//           height: 42,
//           bgcolor: "#C7D3EA1F",
//         }}
//       >
//         <Box component={Google} sx={{ width: "30px", height: "30px" }} />
//       </Box>
//       <Typography sx={{ color: "#D7D7D7" }}>
//         {selectedAction?.action_display_name}
//       </Typography>
//     </Box> */}

//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         gap: 2,
//         color: "#fff",
//       }}
//     >
//       <Box>
//         <Typography>
//           Google Calendar account<span style={{ color: "red" }}>*</span>
//         </Typography>
//         <TextField
//           variant="outlined"
//           fullWidth
//           size="small"
//           sx={{
//             bgcolor: "#171717",
//             input: { color: "#474747", backgroundColor: "#D8D8D8" },
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": { borderColor: "#444" },
//               "&:hover fieldset": { borderColor: "#666" },
//               "&.Mui-focused fieldset": { borderColor: "#888" },
//             },
//           }}
//           InputLabelProps={{ style: { color: "#A1A1A1" } }}
//         />
//       </Box>
//       {/* <Box>
//         <Typography>
//           BlockId<span style={{ color: "red" }}>*</span>
//         </Typography>
//         <TextField
//           variant="outlined"
//           fullWidth
//           size="small"
//           sx={{
//             bgcolor: "#171717",
//             input: { color: "#474747", backgroundColor: "#D8D8D8" },
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": { borderColor: "#444" },
//               "&:hover fieldset": { borderColor: "#666" },
//               "&.Mui-focused fieldset": { borderColor: "#888" },
//             },
//           }}
//           InputLabelProps={{ style: { color: "#A1A1A1" } }}
//         />
//       </Box> */}
//       <Box>
//         <Typography>
//           BlockId <span style={{ color: "red" }}>*</span>
//         </Typography>
//         <TextField
//           select
//           defaultValue="ai"
//           variant="outlined"
//           fullWidth
//           size="small"
//           sx={{
//             bgcolor: "#171717",
//             input: { color: "#474747", backgroundColor: "#D8D8D8" },
//             "& .MuiOutlinedInput-root": {
//               "& fieldset": { borderColor: "#444" },
//               "&:hover fieldset": { borderColor: "#666" },
//               "&.Mui-focused fieldset": { borderColor: "#888" },
//               backgroundColor: "#D8D8D8", // to make dropdown match input
//             },
//           }}
//           InputLabelProps={{ style: { color: "#A1A1A1" } }}
//         >
//           <MenuItem value="ai">
//             Have AI generate a value for this field
//           </MenuItem>
//           <MenuItem value="manual">
//             Set a specific value for this field
//           </MenuItem>
//         </TextField>
//       </Box>
//     </Box>
//   </Box>
// </CommonModal>
